export interface IFilterItem {
  id: string
  name: string
  options: IFilterOption[]
  selected: string[]
  hide: boolean
  type: FilterItemType
}

export interface IFilterOption {
  name: string
  value: string
}

export enum FilterItemType {
  Checkbox,
  Select,
  SingleCheckbox
}

export interface IFilterUpdate {
  id: string
  selected: string[]
}

export interface IFilterUpdate {
  id: string
  selected: string[]
}
